import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from '@/App'
import { applyTheme, getTheme } from '@/lib/theme'
import '@/styles.css'

applyTheme(getTheme())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
